var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cache',{ref:"cache",attrs:{"get-data":_vm.getOrganization,"id":_vm.$route.query.id},scopedSlots:_vm._u([{key:"default",fn:function({data}){return _c('CooperateOrganizationDetail',{attrs:{"group":data,"type":_vm.type},on:{"refresh":function($event){return _vm.$refs.cache.retry()}}})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }